import {deleteData, postData, postMediaData} from 'helpers/apiHelper'
import { DELETE_UPLOADED_FILE, GET_PRESIGNED_URL, MAIN_PATH, UPLOAD_FILE_PATH } from './apiPath'
import { uploadFile } from "store/actions/file";
import { ERROR_MESSAGE } from "common/constantMessage";
import Axios from "axios";

//upload image
export function uploadImage_(value, callback) {
  let url = `${MAIN_PATH}${UPLOAD_FILE_PATH}`;
  return (dispatch) => postMediaData(url, value)
      .then((data) => {
        dispatch(uploadFile(data, callback));
        return data;
      });
}

export function deleteUploadedFile(payload) {
  let url = `${MAIN_PATH}${DELETE_UPLOADED_FILE}`;
  return deleteData(url, payload);
}

// upload image s3 pre-signed url
export async function uploadFilePresignedUrl(payload, callback) {
  try {
    const { file, values } = payload;
    
    let response = await postData(`${MAIN_PATH}${GET_PRESIGNED_URL}`, values);
    const {url, public_url} = response?.body;
    if(!url) {
      throw new Error("Failed to generate presign url");
    }

    const fileUrl = url.split("?")[0];

    await Axios.put(url, file, {
      headers: {
        'Content-Type': file.type
      }
    });

    return {fileUrl, public_url}
  } catch(error) {
    ERROR_MESSAGE("Failed to upload file");
    throw error;
  }
}